import React from 'react'
import { signIn } from '../../actions/AuthActions'
import { LoginContainer, LoginInner, LoginHeading, Form, FieldsWrapper, FieldDiv, SubmitWrapper } from './styled-elements'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText';
import { Button } from '../../styles/styled-elements'

export default class LoginForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      email: null,
      password: null,
      hasErrors: false,
      formErrors: null,
      errors: null
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.apiAuth.errors!==prevProps.apiAuth.errors)
    this.setState({
      formErrors: this.props.apiAuth.errors
    })
  }

  validate = (callback) => {
    const errors = {}
    const { email, password } = this.state
    if (!email) {
      errors.email = 'Email address is required'
    }
    if (!email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
      errors.email = 'Must be a valid email address'
    }
    if (!password) {
      errors.password = 'Password is required'
    }
    if (password.length < 6) {
      errors.password = 'Password is too short'
    }
    if (Object.keys(errors).length) {
      this.setState({
        hasErrors: true,
        errors: errors
      })
    } else {
      callback.call(this)
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.setState({
      hasErrors: false,
      formErrors: null,
      errors: null,
    })
    const { email, password } = this.state
    this.validate(() => { this.props.dispatch(signIn({email, password})) })
  }

  renderBody = (props,state) => <LoginContainer>
    <LoginInner>
      <LoginHeading>Log Into Panorama</LoginHeading>
      <Form onSubmit={this.handleSubmit}>
        {this.state.formErrors &&
          <FormHelperText style={{textAlign: 'center', fontSize: '1.2em' }} error>{this.state.formErrors}</FormHelperText>
        }
        <FieldsWrapper>
          <FieldDiv>
            <TextField
              label="Email"
              name="email"
              inputProps={{
                autocorrect: 'off',
                autocapitalize: 'none',
                autocomplete: 'email',
              }}
              value={this.state.email || ''}
              onChange={(e) => this.setState({email: e.target.value.trim()})}
              error={state.errors && state.errors.email}
              style={{ width: '100%' }}
            />
            <FormHelperText error>{state.errors && state.errors.email}</FormHelperText>
          </FieldDiv>
          <FieldDiv>
            <TextField
              label="Password"
              name="password"
              type="password"
              inputProps={{
                autocomplete: 'current-password',
              }}
              value={this.state.password || ''}
              onChange={(e) => this.setState({password: e.target.value})}
              error={state.errors && state.errors.password}
              style={{ width: '100%' }}
            />
            <FormHelperText error>{state.errors && state.errors.password}</FormHelperText>
          </FieldDiv>

        </FieldsWrapper>
        <SubmitWrapper>
          <Button primary rounded>Log in</Button>
        </SubmitWrapper>
      </Form>
    </LoginInner>
  </LoginContainer>

  render() {
    return this.renderBody(this.props,this.state)
  }
}



// WEBPACK FOOTER //
// ./src/components/login_form/index.js